/*
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2024 UNESP Universidade Estadual Paulista "Júlio de Mesquita Filho"
 * Copyright 2024-2026 UNICAMP Universidade Estadual de Campinas
 *
 */

export const environment = {
  envName: 'development',
  enableConsoleLog: false,
  production: false,
  baseUrlApi: 'https://gestao.tkg-des.nuvem.unicamp.br/sinsc-api',
  sensediaClientId: 'a6dfb2bb-abba-4be4-a485-3708212c60d0',
  sensediaClientSecret: '0e2e8bfc-563d-461f-a675-3fde70c9c772',
  sensediaUrl: 'https://api.unicamp.br',
  allowedFileExtensions: 'pdf,avi,mpg,mpeg,flv,mov,mkv,mp4,zip',
  allowedFileSizeMb: '5000',
  enableTelaContato: 'false',
  usePresignedUrl: 'false',
  minDownloadForChunk: 100,
  enableTelemetry: true,
  telemetryUrl: 'https://grafana-inpe-collector.tkg-des.nuvem.unicamp.br/collect',
}
